import { api } from "@services/baseURL";

// Salva o documento no SharePoint e outras informações no banco de dados
export const SaveDocumentoSharepoint = async (formData) => {
  try {
    const response = await api.post(
      `Documento/upload`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error(
      `Erro ao salvar documento para a solicitação processo item: ${formData.idSolicitacaoProcessoItem}:`,
      error
    );
    throw error;
  }
};

export const DeleteDocumento = async (id) => {
  try {
    await api.delete(`Documento/${id}`);
    return true;
  } catch (error) {
    console.error('Erro ao deletar documento:', error);
    throw error;
  }
};

export const GetAllDocumentos = async (pageSize, rowsPerPage) => {
  try {
    const response = await api.get('Documento', {
      headers: {
        Authorization: `Bearer authToken`,
      },
      params: {
        pageNumber: pageSize,
        pageSize: rowsPerPage,
      },
    });
    return response.data;
  } catch (error) {
    console.error('Erro ao buscar todos os documentos:', error);
    throw error;
  }
};

export const GetByIdDocumento = async (id) => {
  try {
    const response = await api.get(`Documento/${id}`);
    return response.data;
  } catch (error) {
    console.error('Erro ao buscar documentos:', error);
    throw error;
  }
};

export default {
  SaveDocumentoSharepoint,
  DeleteDocumento,
  GetByIdDocumento,
  GetAllDocumentos
};